import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';

const PayPalCancel = () => {
    const navigate = useNavigate();

    return (
        <Result
            icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
            title="Paiement annulé"
            subTitle="Vous avez annulé le paiement PayPal. Aucun montant n'a été débité."
            extra={[
                <Button 
                    type="primary" 
                    key="retry"
                    onClick={() => navigate('/courses')}
                >
                    Retour aux formations
                </Button>,
                <Button 
                    key="home" 
                    onClick={() => navigate('/')}
                >
                    Accueil
                </Button>
            ]}
        />
    );
};

export default PayPalCancel;